module.exports = __webpack_public_path__ + "static/media/13_APOTHEO_LABO_COOPER.80844cf2.png";